export default __webpack_public_path__ + "static/media/icon_kf.b8eccea4.png";